import React, { useEffect, useState } from 'react'

import { getBackendData } from '../../api/api'
import { IPOLStats } from '../../api/interfaces'
import { IChart, IChartConfig } from '../../components/Chart/interface'
import LoadingChart from '../../components/LoadingIcon/Loading'
import ChartPage from '../../pages/ChartPage/ChartPage'
import { useChartData } from '../../hooks/useChartData'
import { colors } from '../../const'

export async function getTotalPolValueConfig(color: string, inverseColor: string, timeframe: string) {
	const chartData = (await getBackendData('thorchain', 'tc_treasury_old_pol_stats', timeframe)) as IPOLStats[]
	const chartData2 = (await getBackendData('thorchain', 'tc_treasury_pol_stats', timeframe)) as IPOLStats[]
	const chartData3 = (await getBackendData('thorchain', 'tc_income_pol_stats', timeframe)) as IPOLStats[]
	const chartData4 = (await getBackendData('thorchain', 'tc_reserve_pol_stats', timeframe)) as IPOLStats[]

	const treasuryOld = chartData.filter((row) => row.POOL_NAME === 'BTC.BTC')
	const treasury = chartData2.filter((row) => row.POOL_NAME === 'BASE.ETH')
	const incomePOL = chartData3.filter((row) => row.POOL_NAME === 'TRON.USDT-TR7NHQJEKQXGTCI8Q8ZY4PL8OTSZGJLJ6T')
	const reserve = chartData4.filter((row) => row.POOL_NAME === 'BTC.BTC')

	const series1 = treasuryOld.map((element: IPOLStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_CURRENT_VALUE_USD }
	})
	const series2 = treasury.map((element: IPOLStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_CURRENT_VALUE_USD }
	})
	const series3 = incomePOL.map((element: IPOLStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_CURRENT_VALUE_USD }
	})
	const series4 = reserve.map((element: IPOLStats) => {
		return { x: new Date(element.DAY).getTime() / 1000, y: element.TOTAL_CURRENT_VALUE_USD }
	})

	const series5 = (() => {
		const sumByDay = new Map<number, number>()

		for (const series of [series1, series2, series3, series4]) {
			for (const { x, y } of series) {
				sumByDay.set(x, (sumByDay.get(x) ?? 0) + y)
			}
		}

		return Array.from(sumByDay, ([x, y]) => ({ x, y })).sort((a, b) => a.x - b.x)
	})()

	const config: IChart[] = []
	config.push(
		{
			data: series5,
			strokeWidth: 2,
			name: `Total Value`,
			type: 'line',
			seriesGroup: '[usd]',
			color: `${color}`,
			unitSymbol: '$'
		},
		{
			data: series1,
			strokeWidth: 2,
			name: `Treasury Old`,
			type: 'line',
			seriesGroup: '[usd]',
			color: `${colors[1]}`,
			unitSymbol: '$'
		},
		{
			data: series2,
			strokeWidth: 2,
			name: `Treasury MSig`,
			type: 'line',
			seriesGroup: '[usd]',
			color: `${colors[2]}`,
			unitSymbol: '$'
		},
		{
			data: series3,
			strokeWidth: 2,
			name: `Income POL`,
			type: 'line',
			seriesGroup: '[usd]',
			color: `${colors[3]}`,
			unitSymbol: '$'
		},
		{
			data: series4,
			strokeWidth: 2,
			name: `Reserve`,
			type: 'line',
			seriesGroup: '[usd]',
			color: `${colors[4]}`,
			unitSymbol: '$'
		}
	)

	return { config: config, latestValue: 0, latestValueDate: 0 }
}

const TotalPolValue = () => {
	const { dataSeries, timeframe, setTimeframe, isLoading, error, retry } = useChartData(getTotalPolValueConfig, '1d')

	if (error) {
		return (
			<div style={{ padding: 40, textAlign: 'center' }}>
				<p>Error loading chart: {error}</p>
				<button onClick={retry}>Retry</button>
			</div>
		)
	}

	if (isLoading || dataSeries === undefined) {
		return <LoadingChart />
	}
	return (
		<ChartPage
			chartTitle="Current Value of POL&Treasury Deployments"
			chartDesc={`Current value of POL&Treasury deployments.`}
			chartDescTitle="Metric Description"
			chartData={dataSeries.config}
			queryId="88fdb846-eb56-4576-bcf0-af576c4443e0"
			timeframe={timeframe}
			setTimeframe={setTimeframe}
			hasHours={false}
			hasLogScale={false}
			sortByValueDesc={true}
		/>
	)
}

export default TotalPolValue
